module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"show_problem_alert","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"levelID":{"type":"string","maxLength":128},"ls":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24}},"required":["user","levelID","ls"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/show_problem_alert.json
// module id = 573
// module chunks = 97